import React, { useEffect, useRef, useState } from 'react';
import style from "../../Style/Components/input.module.scss";
import { toast } from 'react-toastify';

import Recording from '../../Assets/Images/recording.gif';

const SelfPortraitCapture = (props) => {
    const videoRef = useRef(null);
    const mediaRecorderRef = useRef(null);
    const [stream, setStream] = useState(null);
    const [isRecording, setIsRecording] = useState(false);
    const [recordedVideoURL, setRecordedVideoURL] = useState(null);
    const recordedChunks = useRef([]);
    const [timer, setTimer] = useState(10);

    let timer_interval = null;

    useEffect(() => {
        return () => {
            stopCamera(); // cleanup on unmount
        };
    }, []);

    // Start camera immediately when component mounts
    useEffect(() => {
        const timer = setTimeout(() => {
            startCamera();
        }, 20);

        return () => {
            clearTimeout(timer);
        };
    }, []);


    // Setup captured video if provided from props
    useEffect(() => {
        if (props.value) {
            setRecordedVideoURL(props.value);
            stopCamera();
        }
    }, [props.value]);

    useEffect(() => {
        if (recordedVideoURL) {
            stopCamera(); // ✅ Stop camera once video is recorded
        }
    }, [recordedVideoURL]);

    const startCamera = async () => {
        try {
            const mediaStream = await navigator.mediaDevices.getUserMedia({
                video: true,
                audio: true
            });
            setStream(mediaStream);
            if (videoRef.current) {
                videoRef.current.srcObject = mediaStream;
                videoRef.current.onloadedmetadata = () => {
                    videoRef.current.play().catch((err) => {
                        console.error("Error during play():", err);
                    });
                };
            }
        } catch (err) {
            console.error("Error accessing camera:", err);
        }
    };

    const stopCamera = () => {
        try {
            // Stop all tracks from video element
            if (videoRef.current && videoRef.current.srcObject) {
                videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
                videoRef.current.srcObject = null;
            }

            // Stop all tracks from stream in state
            if (stream) {
                stream.getTracks().forEach((track) => track.stop());
            }

            // Clear any media recorder instance
            if (mediaRecorderRef.current && mediaRecorderRef.current.state !== "inactive") {
                mediaRecorderRef.current.stop();
                mediaRecorderRef.current = null;
            }

            setStream(null);
            console.log("✅ Camera fully stopped");
        } catch (err) {
            console.error("❌ Error stopping camera:", err);
        }
    };


    const startRecording = () => {
        recordedChunks.current = [];
        const options = { mimeType: 'video/webm; codecs=vp9' };
        const mediaRecorder = new MediaRecorder(stream, options);

        mediaRecorder.ondataavailable = event => {
            if (event.data.size > 0) {
                recordedChunks.current.push(event.data);
            }
        };

        mediaRecorder.onstop = () => {
            const blob = new Blob(recordedChunks.current, { type: 'video/webm' });
            const videoURL = URL.createObjectURL(blob);
            setRecordedVideoURL(videoURL);
            props.handleCapture(videoURL); // You can change this to blob if needed
        };

        mediaRecorderRef.current = mediaRecorder;
        mediaRecorder.start();

        timer_interval =  setInterval(()=>{
            setTimer(prev => prev-1);
        },1000);
        setIsRecording(true);

        setTimeout(() => {
            if (mediaRecorder.state === "recording") {
                mediaRecorder.stop();
                setIsRecording(false);
                stopCamera();
                setTimer(10);
                clearInterval(timer_interval); 
            }
        }, 10000);
    };

    const stopRecording = () => {
        mediaRecorderRef.current?.stop();
        setIsRecording(false);
        stopCamera();
    };

    const clearVideo = () => {
        setRecordedVideoURL(null);
        startCamera(); // Restart camera for new recording
    };



    return (
        <div>
            <label className="e-label pb-2">Self Video*</label>
            <div className="e-capture-wrapper p-3">
                <div className="d-flex gap-2 align-items-center pb-2">
                    <img
                        src={require('../../Assets/Images/capture.png')}
                        draggable={false}
                        height={18}
                        width={20}
                        alt="capture"
                    />
                    <p className="mb-0 e-title">Verify with a short video</p>
                </div>
                <p className="mb-0 e-description">
                    Record a short video holding your photo ID to verify your identity.
                </p>

                <div className="text-center position-relative pt-3">
                    {
                        isRecording === true ?
                            <div className='e-video-record-indicator'>
                                <span>00:{ timer !== 10 ? '0' : null }{timer}</span>
                                <img src={Recording} />
                            </div>
                            : null
                    }

                    {!recordedVideoURL ? (
                        <>
                            <video
                                ref={videoRef}
                                autoPlay
                                muted
                                style={{ width: '100%', maxWidth: 450, borderRadius: 8 }}
                            />
                            <br />
                            {!isRecording ? (
                                <div className='d-flex gap-3 justify-content-center'>
                                    <button onClick={startRecording} className="mt-2">
                                        Start Recording
                                    </button>
                                </div>
                            ) : (
                                <button onClick={stopRecording} className="mt-2">
                                    Stop Recording
                                </button>
                            )}
                        </>
                    ) : (
                        <div className="text-center mt-3">
                            <p className='e-title'>Recorded Video:</p>
                            <video
                                src={recordedVideoURL}
                                controls
                                style={{ width: '100%', maxWidth: 450, borderRadius: 8 }}
                            />
                            <br />
                            <button onClick={clearVideo} className="mt-2">
                                Record Again
                            </button>
                        </div>
                    )}
                </div>
            </div>

            {props.error && (
                <p className={style.e_error_message}>
                    {props.error}
                </p>
            )}
        </div>
    );
};

export default SelfPortraitCapture;
